/* eslint-disable no-var */
/* eslint-env node */

var DayPickerInput = require('./lib/src/DayPickerInput');

module.exports = DayPickerInput.default || DayPickerInput;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-day-picker/DayPickerInput.js
// module id = 775
// module chunks = 43